import { RestAddressAttributesData } from './fragments.rest';

const type = 'address' as const;

export const createAddressRestObject = (
  {
    firstName,
    lastName,
    addressLine1,
    addressLine2,
    city,
    state,
    postalCode,
    phone,
    countryCode
  }: RestAddressAttributesData,
  id?: string
) => ({
  variables: {
    id,
    input: {
      data: {
        type,
        attributes: {
          first_name: firstName,
          last_name: lastName,
          address_line1: addressLine1,
          address_line2: addressLine2,
          city,
          state,
          postal_code: postalCode,
          phone,
          country_code: countryCode
        }
      }
    }
  }
});
